













































import {
    isMobileLayout,
    useVueRouter,
} from '@superbet-group/web.lib.vue-utilities';
import {
    defineComponent,
    computed,
} from '@vue/composition-api';

import AboutSuperbet from '@modules/layout/footer/components/AboutSuperbet.vue';
import SponsoredEntities from '@modules/layout/footer/components/SponsoredEntities.vue';
import Help from '@modules/layout/footer/components/Help.vue';
import LegalSection from '@modules/layout/footer/components/LegalSection.vue';
import PaymentLinks from '@modules/layout/footer/components/PaymentLinks.vue';
import PrintableOffer from '@modules/layout/footer/components/PrintableOffer.vue';
import SocialLinks from '@modules/layout/footer/components/SocialLinks.vue';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import { getConfig } from '@superbet-group/web.lib.config';
import { Link } from '@src/app/router/constants/Link';
import { Country } from '@superbet-group/web.types';

export default defineComponent({
    name: 'FooterComponent',
    props: {
        isBeingLoaded: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const { route } = useVueRouter();
        const isAppsFooterIframe = computed(() => route.value.meta?.isNativeAppsFooter);
        const showFooter = computed(() => {
            return !(route.value.path.startsWith(Link.Account.Container) && isMobileLayout());
        });
        const sponsoredEntities = shellLocalConfig.sponsoredEntities;

        // TODO(brareg): temporary until we have both .com and brareg (non-prod)
        // after we release brareg, everyone can use 'long info' and we can update Lokalise translation
        const longInfoKey = getConfig().countrySpecific.country === Country.Br
            ? 'long info br'
            : 'long info';

        return {
            isAppsFooterIframe,
            showPrintableOffer: computed(() => (getConfig().sportsOffer?.isRetailFrontendEnabled && !isAppsFooterIframe.value)),
            hasSponsoredEntities: !!shellLocalConfig.sponsoredEntities,
            showFooter,
            sponsoredEntities,
            longInfoKey,
            isMexico: shellLocalConfig.isMexico,
        };
    },
    components: {
        PrintableOffer,
        PaymentLinks,
        Help,
        LegalSection,
        SocialLinks,
        AboutSuperbet,
        SponsoredEntities,
    },
});
